import React from "react";
import { FastField } from "formik";

import { NumberField } from "../../../../../../elements/FormField";
import { numberValidator } from "../../../../../../utils/formValidators";

const GroundClearance = ({ prefix }) => (
  <FastField
    component={NumberField}
    name={`${prefix}.groundClearance`}
    validate={numberValidator({ min: 0, max: 10000 })}
    min={0}
    max={10000}
  />
);

export default GroundClearance;
